import React, { ReactNode, useState } from 'react';

import { Icon, IconColorOptions } from '../Icon';

import './styles.scss';

interface Props {
    children: ReactNode;
    className?: string;
    icon?: string;
    iconSize?: string;
    iconColor?: IconColorOptions;
}

export const HelperModal = ({ className = '', children, icon, iconSize, iconColor }: Props) => {
    const [isVisible, setIsVisible] = useState(true);

    if (isVisible) {
        return (
            <div className={`helper-modal ${className}`}>
                {icon && (
                    <Icon
                        icon={icon}
                        size={iconSize || '16'}
                        color={iconColor || 'info'}
                        className='helper-modal__icon'
                    />
                )}
                <div className='helper-modal__content'>{children}</div>
                <button onClick={() => setIsVisible(false)} className='helper-modal__close-button'>
                    <Icon icon='xmark-regular' className='helper-modal__close-icon' />
                </button>
            </div>
        );
    }

    return null;
};
